/*
 * File: base-cell.ts
 * File Created: 2023-12-18 04:45:49
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-01-10 08:01:14
 * Modified By: Val Liu
 * -----
 */

import { BaseComponent } from "@root/components/base-classes";
import { Component, Prop, PropSync } from "vue-property-decorator";
import { IHeaderCellSort, ITableHeaderCellAttr } from "./core";
import { MetaAttribute } from "@root/core";

/// the base for implement iv-header-cell-*
@Component
export class BaseTableHeaderCell extends BaseComponent implements ITableHeaderCellAttr {
    @Prop({ type: Boolean, required: false, default: false })
    sortable!: boolean;

    @PropSync("sort", { type: String, required: false, default: null })
    syncedSort!: IHeaderCellSort;

    @Prop({ type: Object, required: true })
    metaUnit!: MetaAttribute;
}
